import { Observable, EMPTY as EMPTY_OBSERVABLE } from 'rxjs'
import processSuggestionData from '@aytm/app/stats/lib/draft-js/autocompletePlugin/lib/process-suggestion-data'

const sectionTokenType = 'STR'
const insertAfterToken = 'IN_SECTION'

export default function createSectionSuggestion(
  _,
  __,
  {
    dependencies: {
      aytmLogic: { sections },
      parserResult
    }
  }
) {
  if (!sections || !sections.length || !parserResult) {
    return EMPTY_OBSERVABLE
  }

  const {
    tokens: { expected, type },
    text: { nonParsed }
  } = parserResult

  if ((expected.last && !expected.last.includes(sectionTokenType)) || type.last !== insertAfterToken) {
    return EMPTY_OBSERVABLE
  }

  const transformToSuggestion =
    ({ canBeCompleted, parserResult }) =>
    value => {
      const token = sectionTokenType
      const label = '"' + value.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&') + '"'

      return processSuggestionData('value', { canBeCompleted, token, label, parserResult })
    }

  return new Observable(observer => {
    const canBeCompleted = Boolean(nonParsed)

    sections
      .map(transformToSuggestion({ canBeCompleted, parserResult }))
      .filter(suggestion => suggestion)
      .forEach(suggestion => observer.next(suggestion))

    observer.complete()
  })
}
